const phoneValidationMessage =
  'Enter a 10-digit phone number or include a country code.';
const onlyDigits = (value: string) => value.replace(/\D/g, '');

export const getOptionalPhoneValidationError = (value: string) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return '';

  if (!/^\+?[\d\s().-]+$/.test(trimmedValue)) return phoneValidationMessage;

  const digits = onlyDigits(trimmedValue);
  if (trimmedValue.startsWith('+')) {
    return digits.length >= 8 && digits.length <= 15
      ? ''
      : phoneValidationMessage;
  }

  return digits.length === 10 ||
    (digits.length === 11 && digits.startsWith('1'))
    ? ''
    : phoneValidationMessage;
};

export const getRequiredPhoneValidationError = (value: string) => {
  if (!value.trim()) return 'Enter your phone number.';
  return getOptionalPhoneValidationError(value);
};

export const normalizePhoneForSubmit = (value: string) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return null;

  const digits = onlyDigits(trimmedValue);
  if (trimmedValue.startsWith('+')) return `+${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return `+1${digits}`;
};
